import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Layout from './components/Layout';
import Divination from './pages/Divination';
import IChingLibrary from './pages/IChingLibrary';
import Academy from './pages/Academy';
import Profile from './pages/Profile';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Invitation from './pages/Invitation';
import Splash from './pages/Splash';
import HexagramDetail from './pages/HexagramDetail';
import HexagramTextDetail from './pages/HexagramTextDetail';
import EarlyHeavenTrigramDetail from './pages/EarlyHeavenTrigramDetail';
import ShefuList from './pages/ShefuList';
import ShefuDetail from './pages/ShefuDetail';
import ShefuCreate from './pages/ShefuCreate';
import ShefuEdit from './pages/ShefuEdit';
import { useAuthStore } from './stores/authStore';
import { ENABLE_INVITATION_PAGE } from './config/features';

function App() {
  const [showSplash, setShowSplash] = useState(true);
  const { checkTokenExpiry } = useAuthStore();

  // Check if splash has been shown in this session
  useEffect(() => {
    const splashShown = sessionStorage.getItem('splashShown');
    if (splashShown === 'true') {
      setShowSplash(false);
    }
  }, []);

  // Check token expiry when app loads
  useEffect(() => {
    checkTokenExpiry();
  }, [checkTokenExpiry]);

  const handleSplashFinish = () => {
    sessionStorage.setItem('splashShown', 'true');
    setShowSplash(false);
  };

  if (showSplash) {
    return <Splash onFinish={handleSplashFinish} />;
  }

  return (
    <Router>
      <Routes>
        {ENABLE_INVITATION_PAGE && <Route path="/invitation" element={<Invitation />} />}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/divination" replace />} />
          <Route path="divination" element={<Divination />} />
          <Route path="library" element={<IChingLibrary />} />
          <Route path="academy" element={<Academy />} />
          <Route path="academy/shefu" element={<ShefuList />} />
          <Route path="academy/shefu/create" element={<ShefuCreate />} />
          <Route path="academy/shefu/:id" element={<ShefuDetail />} />
          <Route path="academy/shefu/:id/edit" element={<ShefuEdit />} />
          <Route path="profile" element={<Profile />} />
          <Route path="hexagram/:binary" element={<HexagramDetail />} />
          <Route path="hexagram/:binary/text" element={<HexagramTextDetail />} />
          <Route path="hexagram/:binary/text/:index" element={<HexagramTextDetail />} />
          <Route path="trigram/:binary" element={<EarlyHeavenTrigramDetail />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;